import { AVATAR_SIZES as USER_PHOTO_SIZES } from '@gettactic/components/src/components/UserAvatar/UserAvatar';
import { UserAvatar } from '@gettactic/components/src/components/UserAvatar/UserAvatar';

const UserPhotoCard = UserAvatar;

export { USER_PHOTO_SIZES, UserPhotoCard };